// This file is generated. DO NOT EDIT.
import type { TestDriver, TestElement } from '@oracle/oraclejet-testing/UNSAFE_Driver';
import type { ElementLocator } from '@oracle/oraclejet-testing/UNSAFE_Locators';
import { NumberInputTextAdapter } from './NumberInputTextAdapter';

/**
 * Get the test adapter for the Preact NumberInputText, identified by the given locator.
 * If a driverOrElement is given, the locator will be searched from there.
 * @param locator The ElementLocator used to search for the NumberInputText
 * @param driverOrElement The optional TestDriver or TestElement from which to search. If
 * TestElement is given, locator will search underneath that element. If TestDriver is given
 * or the parameter is undefined, the DOM is searched globally.
 * @returns The test adapter for NumberInputText
 */
export function findNumberInputText(
  locator: ElementLocator,
  driverOrElement?: TestDriver | TestElement
) {
  return new NumberInputTextAdapter(locator, driverOrElement);
}
